import { useRouter } from "next/router"
import { observer } from "mobx-react"
import classNames from "classnames"
import { useStore } from "@features/common"
import { RouterLink } from "@lib/routing"
import { FireIcon } from "@lib/icons/fire-icon"

export const LegalNavigation = observer(function LegalNavigation() {
  const { GlobalModel } = useStore()

  const router = useRouter()

  const getPath = (data: { href?: string; path?: string }) => {
    const { href, path = "" } = data
    if (href) {
      return href + (GlobalModel.lang === "zh" ? "ch" : GlobalModel.lang)
    }
    return path
  }

  return (
    <div className="space-y-5">
      <NavigationItem
        text={GlobalModel.getTemplate("menu.main")}
        uri={getPath({ href: "https://pure.app/" })}
        routing={false}
        onClick={GlobalModel.closeMenu}
      />
      <NavigationItem
        text={GlobalModel.getTemplate("menu.faq")}
        uri={getPath({ path: "/faq" })}
        isActive={router.pathname.includes("/faq")}
        availableInChinese={true}
        availableInSpanish
        routing={true}
        onClick={GlobalModel.closeMenu}
      />
      <NavigationItem
        text={GlobalModel.getTemplate("menu.blog")}
        uri={getPath({ path: "/journal" })}
        isActive={router.pathname.includes("/journal")}
        routing={true}
        onClick={GlobalModel.closeMenu}
      />
      <NavigationItem
        text={GlobalModel.getTemplate("menu.cityguides")}
        uri={getPath({ href: "https://cityguides.pure.app/" })}
        routing={false}
        onClick={GlobalModel.closeMenu}
      />
      {GlobalModel.specProjectsByLang.map((project) => {
        if (project.in_journal) {
          return (
            <NavigationItem
              key={project.slug}
              text={project.text}
              uri={getPath({ path: project.url })}
              onClick={GlobalModel.closeMenu}
              routing={true}
              isActive={router.pathname.includes(project.url)}
              isSpec={true}
              dataTestId="navigation__special_project"
            />
          )
        }
        return null
      })}
      <NavigationItem
        text={GlobalModel.getTemplate("menu.aboutUs")}
        uri={getPath({ path: "/about-us" })}
        isActive={router.pathname.includes("/about-us")}
        routing={true}
        onClick={GlobalModel.closeMenu}
      />
      {GlobalModel.existPublishedVacancies && (
        <NavigationItem
          text={GlobalModel.getTemplate("menu.careers")}
          uri={getPath({ path: "/careers" })}
          isActive={router.pathname.includes("/careers")}
          routing={true}
          onClick={GlobalModel.closeMenu}
        />
      )}
      {GlobalModel.pressLink.enabled &&
        (GlobalModel.countryCode || "").toLowerCase() !== "ru" && (
          <NavigationItem
            text={GlobalModel.getTemplate("menu.press")}
            uri={getPath({ path: GlobalModel.pressLink.url })}
            routing={false}
            onClick={GlobalModel.closeMenu}
          />
        )}
    </div>
  )
})

type NavigationItemProps = {
  text: string
  uri: string
  routing: boolean
  availableInChinese?: boolean
  availableInSpanish?: boolean
  isActive?: boolean
  onClick: () => void
  dataTestId?: string
  isSpec?: boolean
}
const NavigationItem = (props: NavigationItemProps) => {
  const {
    text,
    uri,
    routing,
    availableInChinese,
    availableInSpanish,
    isActive,
    onClick,
    dataTestId,
    isSpec,
  } = props
  return (
    <div>
      <RouterLink
        uri={uri}
        routing={routing}
        availableInChinese={availableInChinese}
        availableInSpanish={availableInSpanish}
        className={classNames(
          "inline-flex items-start font-sans text-2xl tracking-2 uppercase transition-colors duration-100 ease-in hover:text-pink-300",
          {
            "cursor-default pointer-events-none text-pink-300": isActive,
          },
        )}
        onClick={onClick}
        data-test-id={dataTestId}
      >
        <p>{text}</p>
        {isSpec && <FireIcon className="ml-1 shrink-0 w-6 h-6" />}
      </RouterLink>
    </div>
  )
}
